import React from "react";
import { Formik, Form, Field, useFormikContext } from "formik";
import ReactDatePicker from "react-datepicker";

const MeasuredAtDatePicker = ({value, setFieldValue}) => {
  let str;
  if (value instanceof Date) {
    str = `${ (value.getUTCMonth() + 1) }/${ value.getDate() }/${ value.getFullYear() }`;
  }
  const [dateString, setDateString] = React.useState(value);
  const [editing, setEditing] = React.useState(value == null);
  return (
    <Field name="date">
      {({ field, meta }) => {
        return (
          <>
            <label>Measured At Date</label>
            {!editing && (<>
              <b>{dateString}</b>
              <br />
              <a onClick={(el) => {
                setEditing(true);
              }}><i className={'fa fa-edit'}></i> Edit</a>
            </>)}
            {editing && (
              <ReactDatePicker
                {...field}
                autoComplete="off"
                required={true}
                dateFormat={"YYYY-MM-dd"}
                placeholder={"Measured At Date"}
                onChange={(date) => {
                  let dateString = `${ (date.getUTCMonth() + 1) }/${ date.getDate() }/${ date.getFullYear() }`;
                  setDateString(dateString);
                  setEditing(false);
                  setFieldValue("measured_at_date", date);
                }}
              >
              </ReactDatePicker>
            )}
          </>)
      }}
    </Field>
  )
}

export default MeasuredAtDatePicker;
